import {IPresentation} from '../../incase-domain/presentation';
import {IUpdatePresentationRunning} from '../reducer/types/presentation.reducer.types';
import {
    FIND_PRESENTATION_BY_ID,
    GET_PRESENTATION_IN_ROOM,
    IFindPresentationByIdAction,
    IGetPresentationInRoomAction,
    IToggleDrawEnabledAction,
    IToggleRedrawAction,
    IUpdateDrawEnabledAction,
    IUpdateFullPresentation,
    IUpdatePresentation,
    IUpdatePresentationHasSlidesAction,
    IUpdatePresentationStatusAction,
    IUpdatePresLoadingState,
    TOGGLE_DRAW_ENABLED,
    TOGGLE_REDRAW,
    UPDATE_DRAW_ENABLED,
    UPDATE_FULL_PRESENTATION,
    UPDATE_PRES_LOADING_STATE,
    UPDATE_PRESENTATION,
    UPDATE_PRESENTATION_HAS_SLIDES,
    UPDATE_PRESENTATION_RUNNING,
    UPDATE_PRESENTATION_STATUS,
} from './types/dashboard.actions.type';
import {GuestCredentials} from '../../components/presentationView/parts/components/GuestModal';

export const findPresentationByIdAction = (
    id: string,
    credential: GuestCredentials | undefined,
    params: Record<string, string>
): IFindPresentationByIdAction => ({
    type: FIND_PRESENTATION_BY_ID,
    payload: {id, credential, params},
});

export const getPresentationInRoomAction = (
    params: Record<string, string> | undefined,
    credential?: GuestCredentials,
    hash?: string,
    presenterCode?: string
): IGetPresentationInRoomAction => ({
    type: GET_PRESENTATION_IN_ROOM,
    payload: {credential, params, hash, presenterCode},
});

export const updatePresentationAction = (newPresentation: IPresentation): IUpdatePresentation => ({
    type: UPDATE_PRESENTATION,
    payload: newPresentation,
});

export const updatePresentationStatusAction = (status: {found: boolean; id: string}): IUpdatePresentationStatusAction => ({
    type: UPDATE_PRESENTATION_STATUS,
    payload: status,
});

export const updateFullPresentationAction = (presentation: IPresentation): IUpdateFullPresentation => ({
    type: UPDATE_FULL_PRESENTATION,
    payload: presentation,
});

export const updatePresentationHasSlidesAction = (hasSlides: boolean): IUpdatePresentationHasSlidesAction => ({
    type: UPDATE_PRESENTATION_HAS_SLIDES,
    payload: hasSlides,
});

export const updatePresentationRunning = (presentationRunning: boolean): IUpdatePresentationRunning => ({
    type: UPDATE_PRESENTATION_RUNNING,
    payload: presentationRunning,
});

export const toggleDrawEnabledAction = (): IToggleDrawEnabledAction => ({
    type: TOGGLE_DRAW_ENABLED,
});

export const toggleRedrawAction = (): IToggleRedrawAction => ({
    type: TOGGLE_REDRAW,
});

export const updatePresLoadingStateAction = (loading: number): IUpdatePresLoadingState => ({
    type: UPDATE_PRES_LOADING_STATE,
    payload: loading,
});

export const updateDrawEnabledAction = (drawEnabled: boolean): IUpdateDrawEnabledAction => ({
    type: UPDATE_DRAW_ENABLED,
    payload: drawEnabled,
});
